import { Sentiment } from "@edgetier/watchtower-types";
import { faFaceAngry, faSmile, faThumbsUp } from "@fortawesome/pro-regular-svg-icons";
import { unreachableCaseError } from "./unreachable-case-error";
const { faFaConfusion, faHandHoldingHeartOutline } = require("@awesome.me/kit-67bf90e9a4/icons/kit/custom");

/**
 * Get the sentiment icon based on the sentiment.
 *
 * @param sentiment The sentiment to get the icon for.
 * @returns The sentiment icon.
 */
export const getSentimentIcon = (sentiment: Sentiment) => {
    switch (sentiment) {
        case Sentiment.Confusion:
            return faFaConfusion;
        case Sentiment.Frustration:
            return faFaceAngry;
        case Sentiment.Praise:
            return faThumbsUp;
        case Sentiment.Gratitude:
            return faSmile;
        case Sentiment.Empathy:
            return faHandHoldingHeartOutline;
        default: {
            unreachableCaseError(sentiment);
            return null;
        }
    }
};
